export const getParamsFromPath = (path: string): string[] => {
    return (path.match(/:\w+/g) || []).map((sting) => sting.replace(':', ''));
};
